var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDashboardLimit = function SvgDashboardLimit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 3.965a10.035 10.035 0 0 1 8.69 15.052.6.6 0 0 1-1.04-.601 8.835 8.835 0 1 0-15.3 0 .6.6 0 0 1-1.04.6A10.036 10.036 0 0 1 12 3.966m3.42 5.907a.5.5 0 0 1 .707.707l-3.774 3.773a.5.5 0 0 1-.706-.707z"
  })));
};
export default SvgDashboardLimit;